<template>
  <div class="flashcard-header">
    <span>{{ titleText }}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    titleText: String,
  },
};
</script>

<style lang='scss' scoped>
.flashcard-header {
  display: flex;
  justify-content: space-between;
  background-color: #3E67C5;
  color: white;
  border-radius: 0 1.25rem 0 0;
  margin-top: 1rem;
  padding: 1rem 2rem 1rem 4.5rem;
  font-size: 24px;
  font-weight: 600;
  line-height: 2.5rem;
}
</style>
